import { Component, booleanAttribute, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';
import { OrderData, SubStateItem } from '@lfw/roesberg.liveforms.core';

@Component({
  selector: 'lfw-sub-state-select',
  imports: [MatSelect, MatOption, MatFormFieldModule, FormsModule],
  templateUrl: './sub-state-select.component.html',
  styleUrl: './sub-state-select.component.css'
})
export class SubStateSelectComponent {
  readonly availableStates = input.required<SubStateItem[]>();
  readonly order = model.required<OrderData>();
  readonly changed = output<SubStateItem | undefined>();
  readonly disabled = input(false, { transform: booleanAttribute });

  options = computed(() => {
    const currentSubState = this.order().orderSubState;
    if (currentSubState && !this.availableStates().find((state) => state.text === currentSubState.text)) {
      const deprecatedOption = currentSubState;
      deprecatedOption.text = `${currentSubState.text}`;
      deprecatedOption.displayText = `⛔ ${currentSubState.text}`;
      return [undefined, ...this.availableStates(), deprecatedOption];
    }
    return [undefined, ...this.availableStates()];
  });

  getSelectedItemStyle(): string {
    if (!this.order()?.orderSubState) {
      return '';
    }
    return this.order().orderSubState?.getStyle() || '';
  }

  getItemStyle(item: SubStateItem | undefined): string | undefined {
    return item?.getStyle();
  }

  setSelectedValue(value: SubStateItem | undefined): void {
    this.order.update((order) => {
      order.orderSubState = value;
      return order;
    });
    this.changed.emit(value);
  }

  compareFn(prev?: SubStateItem, curr?: SubStateItem): boolean {
    return prev?.text === curr?.text;
  }
}
